import { subPlantHistoryReport } from "@gtpl/shared-models/production-management"
import { ApiProperty } from "@nestjs/swagger"

export class GRNLocationMappingRequest {
    @ApiProperty()
    grnUnitId: number 
    @ApiProperty()
    vendorId: number
    @ApiProperty()
    vendorName: string
    @ApiProperty()
    itemId: number
    @ApiProperty()
    itemName: string
    @ApiProperty()
    brandId: number
    @ApiProperty()
    invoiceNumber:string
    @ApiProperty()
    receivedQty:number
    @ApiProperty()
    saleOrderId:number
    @ApiProperty()
    itemCategoryId:number
    @ApiProperty()
    itemSubCategoryId:number
    @ApiProperty()
    unitPrice:number
    @ApiProperty()
    grnId:number
    @ApiProperty()
    grnItemId:number
    @ApiProperty()
    sizeId:number
    @ApiProperty()
    poId:number
    @ApiProperty()
    locationId?:number
    @ApiProperty()
    physicalQuantity?:number
    @ApiProperty()
    locationStatus?:string
    @ApiProperty()
    createdUser?:string
    
    
}
